import { Box } from '~/ds-components'
import { LedRing } from '~/components/LedRing'
import * as Styles from './WheelBorder.styles'

type WheelBorderProps = {
  children?: React.ReactNode
  slotProps?: { mainRing?: Styles.MainRingPropsType }
}

export const WheelBorder = (props?: WheelBorderProps) => {
  const { children, slotProps } = props || {}

  return (
    <Box
      sx={{
        height: '100%',
        maxHeight: '477px',
        maxWidth: '477px',
        position: 'relative',
        width: '100%',
      }}
    >
      <LedRing />
      <Styles.WheelContainer>
        <Styles.MainRing {...slotProps?.mainRing}>
          <Styles.CenterCircle />
          <Styles.WheelContent className="wheel-content">{children}</Styles.WheelContent>
        </Styles.MainRing>
      </Styles.WheelContainer>
    </Box>
  )
}
